<template>
  <div class="project-layout">
    <slot></slot>
    <div v-if="shownCreate" class="project-card-empty" @click="goToProjectCreate">
      <div class="project-card-icon-overlay">
        <div class="project-card-icon"></div>
      </div>
      <div class="project-card-label">
        {{ $t('common.create') }}
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTES } from '@/pages/projects/const';

export default {
  name: 'ProjectLayout',
  props: {
    shownCreate: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    goToProjectCreate() {
      this.$router.push({ name: ROUTES.projectCreate });
    },
  },
};
</script>

<style lang="sass" scoped>
  .project-layout
    display: flex
    flex-flow: column wrap
    align-items: center
    padding-bottom: 30px

    +respond-to(small)
      width: 100%
      max-width: 620px
      display: grid
      grid-template-columns: 1fr 1fr
      grid-gap: 20px
      margin: 0 auto
      padding: 20px 0 30px

    .project-card
      margin-bottom: 20px

      +respond-to(small)
        margin-bottom: 0

  .project-card-empty
    width: calc(100% - 40px)
    height: 400px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    background-color: rgba(39, 40, 60, 0.5)
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.15)
    border-radius: 5px
    transition: background-color linear .1s
    cursor: pointer

    +respond-to(small)
      width: 280px

    +respond-to(medium)
      width: 300px

    &:hover
      background-color: #27283c

  .project-card-icon-overlay
    width: 60px
    height: 60px
    position: relative
    display: flex
    align-items: center
    justify-content: center
    border-radius: 50%
    background-color: #181722

    #{theme('eclipse')} &
      background-color: #e5e5e5

    #{theme('obsidian')} &
      background-color: #181822

  .project-card-icon
    width: 40px
    height: 40px
    background-repeat: no-repeat
    background-position: center
    background-color: #27283c
    border-radius: 50%

    #{theme('eclipse')} &
      background-image: get-icon('plus', #212121)

    #{theme('obsidian')} &
      background-image: get-icon('plus', #fff)

  .project-card-label
    margin-top: 20px
    font-size: 14px
    line-height: 17px
    color: #fff
    opacity: .2
</style>
